import { getCookie } from './tokens';

export const getFunctionsBaseUrl = () => {
    return '/.netlify/functions/';
};

/**
 * The signed-in user's token for a Netlify function call. Functions that spend the OpenAI key or fetch
 * server-side reject calls without it; the venue AI functions use it to read unpublished venues.
 */
export const getFunctionAuthHeaders = (): Record<string, string> => {
    const token = getCookie();
    return token ? { Authorization: `Bearer ${token}` } : {};
};
